<template>
  <search-service />
</template>
<script>
import searchService from '~/pages/search/searchService'

import Promise from 'bluebird'

// nuxt.config.jsに書いてもグローバルに効かなかったのでローカルで設定する
Promise.config({ cancellation: true })

export default {
  name: 'search',
  components: {
    searchService
  }
}
</script>
